<template>
    <div class="main-container px-5  xl:px-8">
        <Toast />
        <AdminHome v-if="isAdmin" />
        <UserHome v-else/>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useToast } from 'primevue/usetoast';
import AdminHome from "./AdminHome.vue";
import UserHome from "./UserHome.vue";
const toast = useToast();
import { useStore } from 'vuex';

const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);
</script>

<style scoped>
/* Your styles here */
:deep(.p-togglebutton) {
width: 50%;
}
</style>